// Progressive enhancement for the server-rendered `_search_form` boxes:
// wires the on-brand clear + share controls. The React active-listings island
// (`SellingSearch`) manages its own controls in React, so it is deliberately
// NOT marked with `data-search-controls` and is skipped here.

const COPIED_RESET_MS = 2000

function syncControls(input, clear, share) {
  const hasValue = input.value.trim().length > 0

  if (clear) clear.hidden = !hasValue
  if (share) {
    share.classList.toggle('search-controls__share--with-clear', hasValue)
  }
}

// clearing resets the applied filter, so submit back to the unfiltered view
function wireClear(field, input, clear, onSync) {
  clear.addEventListener('click', () => {
    input.value = ''

    const form = input.form || field.closest('form')

    if (form) form.submit()
    else onSync()
  })
}

function wireShare(input, share) {
  let resetTimer

  share.addEventListener('click', async () => {
    const url = new URL(window.location.href)
    const param = input.getAttribute('name') || 'search'
    const trimmed = input.value.trim()

    if (trimmed) url.searchParams.set(param, trimmed)
    else url.searchParams.delete(param)

    try {
      await navigator.clipboard.writeText(url.toString())
      share.dataset.copied = 'true'
      share.setAttribute('title', 'Link copied')
      window.clearTimeout(resetTimer)
      resetTimer = window.setTimeout(() => {
        delete share.dataset.copied
        share.setAttribute('title', 'Copy a shareable link')
      }, COPIED_RESET_MS)
    } catch {
      // clipboard unavailable (insecure context / denied) — nothing to do
    }
  })
}

function wireField(field) {
  const input = field.querySelector('.input--search')

  if (!input) return

  const clear = field.querySelector('[data-search-clear]')
  const share = field.querySelector('[data-search-share]')
  const sync = () => syncControls(input, clear, share)

  input.addEventListener('input', sync)
  sync()

  if (clear) wireClear(field, input, clear, sync)
  if (share) wireShare(input, share)
}

export default function initSearchControls() {
  document.querySelectorAll('[data-search-controls]').forEach(wireField)
}

document.addEventListener('DOMContentLoaded', initSearchControls)
